import { T as h, _ as c } from "./directive-CvGfmxqC.js";
import { t as m } from "./uid-DGLBmjXH.js";
const o = class l extends c {
  constructor() {
    super(...arguments), this.uuid = m(), this.slotHasEvent = !1, this.usingParentElement = !1, this.containerSelector = "", this.totalSlottedElements = 0, this.handleSlotchange = (t) => {
      if (t.eventPhase !== 2)
        return;
      const s = t.target, a = s == null ? void 0 : s.assignedElements();
      let e;
      this.totalSlottedElements = a.length, this.containerSelector ? e = this.findContainerElement(s) : e = this.usingParentElement ? s.parentElement : s, this.totalSlottedElements < 1 ? (e == null || e.classList.add(l.defaultClassName), e == null || e.classList.remove(this.hasSlottedClassName)) : (e == null || e.classList.remove(l.defaultClassName), e == null || e.classList.add(this.hasSlottedClassName));
    };
  }
  get hasSlottedClassName() {
    return `has-slotted-${this.uuid}`;
  }
  findContainerElement(t) {
    if (this.containerSelector)
      return t.closest(this.containerSelector);
  }
  /** Create and append a small set of styles when the directive is used. */
  static createStyleElement(t) {
    const s = document.createElement("style");
    s.innerHTML = `.${l.defaultClassName}:not([class*='has-slotted-']) {display: none !important;}`, s.id = l.stylesID, t.appendChild(s);
  }
  update(t, [s = { useParent: !1 }]) {
    const { useParent: a, container: e } = s, n = t.element, r = n.getRootNode(), { parentElement: d } = n;
    a && (this.usingParentElement = !0), e && (this.containerSelector = e);
    const i = {};
    return this.containerSelector ? i.element = this.findContainerElement(n) : a && d ? i.element = d : i.element = n, r.querySelector(`#${l.stylesID}`) || l.createStyleElement(r), this.slotHasEvent || (n.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(i);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ element: t } = { useParent: !1 }) {
    t && this.totalSlottedElements < 1 && (t.classList.add(l.defaultClassName), t.classList.remove(this.hasSlottedClassName)), t && this.totalSlottedElements >= 1 && t.classList.add(this.hasSlottedClassName);
  }
};
o.defaultClassName = "hide-slot-area", o.stylesID = "show-if-used-directive-styles";
let u = o;
const f = h(u);
export {
  f as u
};
